<template>
    <div class="wrapper-landing">
        <div class="media" v-for="photo in photos" :key="photo.id">
            <div class="layer" :id="'layer-' + photo.id">
                <router-link
                    class="photo-link"
                    :to="{name: `${photo.formUrl ? photo.formUrl : null}`}"
                    exact
                >
                    <p class="photo-title">{{ photo.title }}</p>
                </router-link>
            </div>
            <div>
                <img :src="thumbUrl(photo.filename)" />
                <div class="media-item-footer">
                    <router-link
                        v-if="photo.formUrl"
                        :to="{
                            name: `${photo.formUrl ? photo.formUrl : null}`,
                        }"
                        exact
                    >
                        Submit &rarr;
                    </router-link>
                    <span>Closing Date: {{ photo.date }}</span>
                </div>
            </div>
        </div>
        <div class="circles-media">
            <div class="media">
                <div class="layer-visible">
                    <p>Prize Designs </br> for Modern </br> Furniture and </br> Lighting</p>
                </div>
                <div>
                    <img class="circle-image" src="/images/thumb6a.png" />
                    <div class="media-item-footer">
                        <a href="prize-designs-for-modern-furniture-lighting" style="width:100%; text-align:center;cursor:pointer;">
                            Submit &rarr;
                        </a>
                    </div>
                </div>
            </div>
            <div class="media" style="margin-right:30px;cursor:pointer;">
                <div class="layer-visible">
                    <p>Future </br> House Award - </br> International </br> Residential</br> Awards</p>
                </div>
                <div>
                    <img class="circle-image" src="/images/thumb6b.png" />
                    <div class="media-item-footer">
                        <a href="future-house-awards" style="width:100%; text-align:center;">
                            Submit &rarr;
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Grid",
    data() {
        return {
            photos: [
                {
                    id: 0,
                    title: "The Good \n Design Award",
                    filename: "thumb1.jpg",
                    formUrl: "good-design-award",
                    date: "June 15th",
                },
                {
                    id: 1,
                    title: "The Green Good \n Design Award",
                    filename: "thumb2.jpg",
                    formUrl: null,
                    formUrl: "green-good-design-award",
                    date: "January 15th",
                },
                {
                    id: 2,
                    title: "The American \n Architecture Award",
                    filename: "thumb3.jpg",
                    formUrl: null,
                    formUrl: "american-architecture-award",
                    date: "February 1st",
                },
                {
                    id: 3,
                    title: "The International \n Architecture Award",
                    filename: "thumb4.jpg",
                    formUrl: null,
                    formUrl: "international-architecture-award",
                    date: "December 1st",
                },
                {
                    id: 4,
                    title: "The Europe \n 40under40 Award",
                    filename: "thumb5.jpg",
                    formUrl: null,
                    formUrl: "europe40under40-design-award",
                    date: "December 15th",
                },
            ],
        };
    },
    methods: {
        thumbUrl(filename) {
            return `/images/${filename}`;
        },
    },
};
</script>

<style>
.wrapper-landing {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 60px;
    width: 100%;
    flex-wrap: wrap;
    gap: 60px;

    .media {
        max-width: 100%;
        width: 580px;
        height: auto;
        overflow: hidden;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        @media (max-resolution: 1dppx) {
            height: 360px;
        }
    }

    .media-item-footer {
        display: flex;
        padding-top: 10px;
        height: 50px;
        flex-direction: column;
        @media (max-resolution: 1dppx) {
            flex-direction: row;
        }
        a {
            font-size: 14pt;
            color: #000000;
        }
        span {
            margin-left: auto;
            font-size: 14pt;
            font-weight: bold;
            color: #000000;
        }
    }

    .media img {
        max-width: 100%;
        height: auto;
    }

    .layer, .layer-visible {
        opacity: 1;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        margin-bottom: 133px;
        background: #fff;
        color: #fff;
        cursor: pointer;
        @media (max-resolution: 1dppx) {
            margin-bottom: 87px;
        }
    }

    .photo-title{
        color: #fff;
    }

    .photo-link{
        text-decoration: none;
    }

    p {
        text-align: center;
        @media (max-resolution: 1dppx) {
            font-size: 24pt;
        }
        font-size: 18pt;
        font-weight: bold;
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10 and IE 11 */
        user-select: none; /* Standard syntax */
        white-space: pre-wrap;
    }

    .circles-media{
        display: flex;
        max-width: 580px;
        flex-direction: column;
        @media (max-resolution: 1dppx) {
            flex-direction: row;
        }
    }

    .layer-visible {
        opacity: 1;
        background: transparent;
        color: #000;
        p {
            text-align: center;
            @media (max-resolution: 1dppx) {
                font-size: 16pt;
                padding-top: 0px;
            }
            padding-top: 60px;
            font-size: 16pt;
            font-weight: bold;
            -webkit-user-select: none; /* Safari */
            -ms-user-select: none; /* IE 10 and IE 11 */
            user-select: none; /* Standard syntax */
            white-space: pre-wrap;
        }    
    }

    .circle-image{
        width: 290px;
        height: 290px;
    }


    #layer-0 {
        p{padding-top: 60px;}
        opacity: 1;
        background: rgba(165, 84, 23, 0.8);
        width: 100%;
        transition: all 0.5s ease;
    }
    #layer-1 {
        p{padding-top: 60px;}
        opacity: 1;
        background: rgba(79, 149, 46, 0.8);
        width: 100%;
        transition: all 0.5s ease;
    }
    #layer-2 {
        p{padding-top: 60px;}
        opacity: 1;
        background: rgba(209, 56, 22, 0.8);
        width: 100%;
        transition: all 0.5s ease;
    }
    #layer-3 {
        p{padding-top: 60px;}
        opacity: 1;
        background: rgba(219, 143, 18, 0.8);
        width: 100%;
        transition: all 0.5s ease;
    }
    #layer-4 {
        p{padding-top: 60px;}
        opacity: 1;
        background: rgba(0, 71, 213, 0.8);
        width: 100%;
        transition: all 0.5s ease;
    }
}


</style>
